<template>
  <div class="add-button" :class="{'add-button--hidden': !isHidden}">
    <i class="fas fa-plus"></i>
  </div>
</template>

<script>
export default {
  name: 'add-button',
  computed: {
    isHidden() {
      return !this.$route.meta.hiddenNav
    }
  }
}
</script>

<style lang="scss" scoped>
  .add-button {
    background-color: $primaryColor;
    width: 46px;
    height: 46px;
    position: fixed;
    bottom: 32px;
    right: 32px;
    border-radius: 50%;
    box-shadow: 0 3px 6px rgba(#000000, 0.16);
    color: #fff;
    transition: 0.3s;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 24px;
    cursor: pointer;

    @media screen and (min-width: #{$media-600}) {
      width: 54px;
      height: 54px;
      font-size: 28px;
    }

    &--hidden {
      bottom: -60px;
    }

    &:hover {
      transform: translateY(-8px);
    box-shadow: 3px 3px 12px rgba(#000000, 0.16);
    }
  }
</style>
